import { useSearch } from '@/src/contexts'

import { Select } from 'antd'

import { distanceOptions, DEFAULT_DISTANCE } from '@/src/data'

export const DistanceFilter = () => {
  const { query, setQuery } = useSearch()

  const handleDistanceChange = async (value: string | number) => {
    const currentLocation = query.geoDistanceParameters?.currentLocation
    if (
      !currentLocation ||
      (currentLocation.lat === 0 && currentLocation.lon === 0)
    ) {
      return
    }

    setQuery((prevQuery) => ({
      ...prevQuery,
      geoDistanceParameters: {
        ...prevQuery.geoDistanceParameters,
        distance: String(value),
      },
    }))
  }

  const hasValidLocation = () => {
    const currentLocation = query.geoDistanceParameters?.currentLocation
    const { city, state, zip } = query.locationParameters || {}

    return (
      currentLocation &&
      (currentLocation.lat !== 0 || currentLocation.lon !== 0) &&
      // Valid combinations:
      ((city && state) || // City, state
        zip || // Just zip
        state || // Just state
        (city && state && zip)) // Full address
    )
  }

  return (
    <Select
      data-testid='distance-select'
      options={distanceOptions}
      defaultValue={DEFAULT_DISTANCE}
      value={query.geoDistanceParameters?.distance}
      onChange={handleDistanceChange}
      disabled={!hasValidLocation()}
    />
  )
}
